export default {"src":"/_next/static/media/calendar.c2e94e50.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};